import React, { Component } from 'react';
import { injectIntl, intlShape, FormattedMessage } from 'react-intl';
import FullbleedHero from '../components/ContentBlocks/FullbleedHero';
import ContactForm from '../components/ContactForm';
import Hours from '../components/Hours';
import { fetchContact } from '../redux/actions';
import { connect } from 'react-redux';
import Loader from '../components/Loader';
import './ContactPage.css';
import ReactMarkdown from 'react-markdown';
import Helmet from 'react-helmet';

class ContactPage extends Component {

  componentDidMount()
  {
    const locale = this.props.intl.locale;
    if (!this.props.contact.header) {
      this.props.fetchContact(locale);
    }
  }

  render() {
    return (
      <div className="contact">
        <Helmet>
          <title>{this.props.intl.messages["header.contactUs"]}</title>
        </Helmet>
        {(!this.props.contact.header && !this.props.contact.headers) && <Loader/>}
        {this.props.contact.headers && <FullbleedHero fields={this.props.contact.headers} dual />}
        <div className="contact-body">
          <div className="container">
            <div className="row">
              <div id="open-hours">
                <div className="left-column">
                  <h3 className="cacheover"><FormattedMessage id="footer.openTitle" /></h3>
                  <Hours text={this.props.hours}/>
                  <Hours text={this.props.hoursSecondColumn}/>
                  {this.props.contact.leftColumn && <ReactMarkdown source={this.props.contact.leftColumn} softBreak="br" />}
                </div>
              </div>
              <div className="right-column">
                <ContactForm />
                {this.props.contact.rightColumn && <ReactMarkdown source={this.props.contact.rightColumn} softBreak="br" />}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

ContactPage.propTypes = {
  intl: intlShape.isRequired,
}

const mapStateToProps = state => ({
  contact:state.contact,
  hours:state.hours,
  hoursSecondColumn: state.hoursSecondColumn
});

const mapDispatchToProps = {
  fetchContact
};

export default connect(mapStateToProps,mapDispatchToProps)(injectIntl(ContactPage));



// WEBPACK FOOTER //
// ./src/containers/ContactPage.js